export default "__VITE_ASSET__9fd97750__"